import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetworkServiceConfigurationSelectorComponent } from './network-service-configuration-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [NetworkServiceConfigurationSelectorComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
  ],
  exports: [NetworkServiceConfigurationSelectorComponent],
})
export class NetworkServiceConfigurationSelectorModule {}
